// 必须这样 不然会出现 undefined case
// const getSecondLevelDomain = hostname => {
//   const [top, main] = hostname.split('.').reverse();
//   return `${main}.${top}`;
// };

// const host = location.hostname;
// const HOST_BODY =
//   process.env.NODE_ENV == 'development' && process.env.VUE_APP_HOST_TYPE
//     ? process.env.VUE_APP_HOST_TYPE
//     : getSecondLevelDomain(host);

export default (env, businessType) => {
  let sUrl = '',
    host = location.hostname;
  if (/-dev|-stg|-pre|localhost|^192\.168|^172\.20|dev\./.test(host)) {
    // dev/stg 环境统一用 huolala
    sUrl = `https://uba-stg.xiaolachuxing.com/sa?project=`;
  } else if (/-stg/.test(host)) {
    //产品说有stg环境了,实际上没有,所以这里改回了dev
    sUrl = `https://uba-dev.huolala.cn/sa?project=`;
  } else if (businessType && businessType === 'lalamove') {
    sUrl = 'https://uba.huolalamove.net:8107/sa/metadata/meta-event/?project=';
  } else {
    sUrl = `https://uba.xiaolachuxing.com/sa?project=`;
  }
  let project = 'default';

  switch (env) {
    case 'driver':
      project = 'production';
      break;
    case 'company':
      project = 'enterprise';
      break;
    case 'xluser':
      project = 'xluser';
      break;
    case 'xldriver':
      project = 'xldriver';
      break;
    default:
      project = 'default';
  }

  return `${sUrl}${project}`;
};
